import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';
import { CircularProgress, Box, Typography } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const [loginOpen, setLoginOpen] = useState(!isAuthenticated);

  if (loading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="400px">
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Checking authentication...
        </Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="400px">
          <Typography variant="h4" gutterBottom>
            Admin Access Required
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Please log in to access the admin panel.
          </Typography>
        </Box>
        <Login 
          open={loginOpen} 
          onClose={() => setLoginOpen(false)}
        />
      </>
    );
  }

  return children;
};

export default ProtectedRoute;